import { IReactDOMAdapter } from '../type';
import * as ReactDOM from 'react-dom';

export const reactDomAdapter17: IReactDOMAdapter = {
    render: (element, container) => {
        ReactDOM.render(element, container);
        return null;
    },
    unmount: (container) => {
        ReactDOM.unmountComponentAtNode(container);
    }
};
